"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeader = void 0;
const react_1 = __importDefault(require("react"));
const Back_1 = require("../../atoms/Back/Back");
const Heading_1 = require("../../atoms/Heading/Heading");
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const PageHeader = ({ back, summary, summaryAction, title, subtitle, className, testing }) => {
    let summaryText;
    if (typeof summaryAction === 'function') {
        summaryText = react_1.default.createElement(Subtitle_1.SubtitleButton, { onClick: summaryAction }, summary);
    }
    else if (typeof summaryAction === 'string') {
        summaryText = react_1.default.createElement(Subtitle_1.SubtitleLink, { to: summaryAction }, summary);
    }
    else {
        summaryText = react_1.default.createElement(Subtitle_1.Subtitle, null, summary);
    }
    return (react_1.default.createElement("div", { className: className },
        back && (react_1.default.createElement("div", { className: "pb-4" }, typeof back === 'function' ? react_1.default.createElement(Back_1.BackButton, { onClick: back }) : react_1.default.createElement(Back_1.BackLink, { to: back }))),
        summaryText,
        react_1.default.createElement(Heading_1.H1, null, title),
        subtitle && (react_1.default.createElement("h3", { "data-testid": testing && 'page-header-subtitle', className: "text-base lg:w-8/12" }, subtitle))));
};
exports.PageHeader = PageHeader;
